<script lang="ts">
	import { user_settings } from 'src/stores/account/user';
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system';

	import { handleEmailPermissions } from './user_permissions_helper';
	import { capFirstChar } from 'src/helpers/utilities';

	import ConfirmEmail from 'src/components/ConfirmEmail.svelte';
	import NotificationToggler from './NotificationToggler.svelte';
</script>

{#if $user_settings.mail_validated === 1}
	<NotificationToggler
		enabled={$user_settings.mail_notifications_permissions}
		description={capFirstChar(
			$format('user_email_notification_enable', {
				default: 'Enable e-mail notifications',
			}),
		)}
		request={handleEmailPermissions}
	/>
{:else}
	<Text styleType="body-small" class="text-color-muted mb-s"
		>{capFirstChar(
			$format('user_email_notification_enable', {
				default: 'Email notifications.',
			}),
		)}
	</Text>
	<ConfirmEmail toastEmailValidationMessage={undefined} />
{/if}
